// 公开站 PV 上报 —— router.afterEach 调
// 设计：sendBeacon 优先（unload 也能送达），5s 内同 path 去重防路由抖动
let lastPath = '';
let lastAt = 0;
const DEDUPE_MS = 5_000;

export function sendTrack(path: string, referer: string | null): void {
  const now = Date.now();
  if (path === lastPath && now - lastAt < DEDUPE_MS) return;
  lastPath = path;
  lastAt = now;

  const payload = {
    path,
    ua: navigator.userAgent,
    // 跨站访问 document.referrer 才有值；同站切换浏览器置空 → 上一页路径回填
    referer: referer && referer.length > 0 ? referer : null,
  };
  const body = JSON.stringify(payload);
  const url = '/api/public/track';

  // sendBeacon 不接受 application/json content-type 直接用，用 Blob 包一层即可
  if (navigator.sendBeacon) {
    try {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
      return;
    } catch {
      // 落到下面 fetch fallback
    }
  }
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => undefined);
}
